import { ProgressIndicator } from '@dnb/eufemia';
import { FormStatus } from '@dnb/eufemia';
import { ContentDto } from '@portals/shared/portal/ContentDto';
import Markdown from '@portals/shared-frontend/components/Markdown';
import useSWR from 'swr';

export function HelpMarkdown({ path }: { path: string | null }) {
  const { data: content, isValidating: loading } = useSWR<ContentDto[]>(path);

  if (loading || path === null) {
    return <ProgressIndicator size="small" type="linear" />;
  }

  if (!content || content.length === 0) {
    return (
      <FormStatus
        state="warning"
        text="Oops! We can't find the content to display here. Please contact us or try again later."
      />
    );
  }

  return (
    <>
      {content.map((c, i) => (
        <Markdown key={i}>{c.blob.content}</Markdown>
      ))}
    </>
  );
}
